import {createStore} from "vuex";
import {tableModule} from '@/store/tableModule'

export default createStore({
    modules: {
        table: tableModule,
    }
});
